"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var EntityChipsComponent = /** @class */ (function () {
    function EntityChipsComponent() {
        this.deleteEvent = new core_1.EventEmitter();
    }
    EntityChipsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isMainEntityField = this.selectedItemFields.map(function (metaField) { return metaField.getMetaFieldId().getMetaCategoryId().getSystemName() === _this.mainEntityCategoryId; });
    };
    EntityChipsComponent.prototype.removeSelectedEntity = function (subEntity) {
        var subEntities = this.entity.getProperty(this.subEntityCategoryId).value;
        subEntities.splice(subEntities.indexOf(subEntity), 1);
        this.selectedSubEntities.splice(this.selectedSubEntities.indexOf(subEntity), 1);
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], EntityChipsComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntityChipsComponent.prototype, "selectedSubEntities", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Array)
    ], EntityChipsComponent.prototype, "selectedItemFields", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntityChipsComponent.prototype, "mainEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntityChipsComponent.prototype, "mainEntityFieldId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntityChipsComponent.prototype, "subEntityCategoryId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Number)
    ], EntityChipsComponent.prototype, "currentLanguageId", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], EntityChipsComponent.prototype, "title", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], EntityChipsComponent.prototype, "deleteEvent", void 0);
    EntityChipsComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-entity-chips',
            template: require('./entity-chips.component.html'),
            styles: [require('./entity-chips.component.css')]
        })
    ], EntityChipsComponent);
    return EntityChipsComponent;
}());
exports.EntityChipsComponent = EntityChipsComponent;
//# sourceMappingURL=entity-chips.component.js.map